import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [tipo, setTipo] = useState(() => localStorage.getItem("tipo"));
  const [usuarioId, setUsuarioId] = useState(() => localStorage.getItem("usuario_id"));
  const [nome, setNome] = useState(() => localStorage.getItem("nome") || "");
  const [fotoUrl, setFotoUrl] = useState(() => localStorage.getItem("foto_url") || "");
  const [validando, setValidando] = useState(true);

  useEffect(() => {
    if (tipo) {
      axios.get(`${API_URL}/me`, { withCredentials: true })
        .then(res => {
          setUsuarioId(String(res.data.id));
          setNome(res.data.nome || "");
          setFotoUrl(res.data.foto_url || "");
          localStorage.setItem("usuario_id", res.data.id);
          localStorage.setItem("nome", res.data.nome || "");
          localStorage.setItem("foto_url", res.data.foto_url || "");
        })
        .catch(() => {
          localStorage.removeItem("tipo");
          localStorage.removeItem("usuario_id");
          localStorage.removeItem("nome");
          localStorage.removeItem("foto_url");
          setTipo(null);
          setUsuarioId(null);
          setNome("");
          setFotoUrl("");
        })
        .finally(() => setValidando(false));
    } else {
      setValidando(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = (userTipo, id) => {
    setTipo(userTipo);
    setUsuarioId(String(id));
    localStorage.setItem("tipo", userTipo);
    localStorage.setItem("usuario_id", String(id));
  };

  const logout = () => {
    axios.get(`${API_URL}/logout`, { withCredentials: true }).catch(() => {});
    localStorage.removeItem("tipo");
    localStorage.removeItem("usuario_id");
    localStorage.removeItem("nome");
    localStorage.removeItem("foto_url");
    setTipo(null);
    setUsuarioId(null);
    setNome("");
    setFotoUrl("");
  };

  const refreshPerfil = () => {
    axios.get(`${API_URL}/me`, { withCredentials: true }).then(res => {
      setNome(res.data.nome || "");
      setFotoUrl(res.data.foto_url || "");
      localStorage.setItem("nome", res.data.nome || "");
      localStorage.setItem("foto_url", res.data.foto_url || "");
    }).catch(() => {});
  };

  return (
    <AuthContext.Provider value={{ tipo, usuarioId, nome, fotoUrl, login, logout, validando, refreshPerfil }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
